/**
 * @file 安全社区首页
 * @author wangzhuang
 */

import {rcAjax} from '../util';
import {GET_CMSAPI_INDEXDATA, GET_CMSAPI_PUBLISH} from './ActionTypes';

export function fetchCmsapiIndexData(dispatch) {
    return rcAjax('GET', '/cmsapi/indexData', {}, {}, data => {
        dispatch({type: GET_CMSAPI_INDEXDATA, data: data.data});
    });
}

export function fetchCmsapiPublish(dispatch, catid, page, isMore) {
    return rcAjax('GET', '/cmsapi/publishArticleList', {catid: catid, page: page}, {}, data => {
        dispatch({type: GET_CMSAPI_PUBLISH, data: data.data, isMore: isMore});
    });
}


// WEBPACK FOOTER //
// ./src/actions/forumAction.js